import { useEffect, useState } from "react";
import { ADMIN_SUBJECT_BY_ID, SUBJECTS_BY_CLASS, ADMIN_ALL_CLASSES } from "../../../Api/Api";
import { Axios } from "../../../Api/axios";
import { Link } from "react-router-dom";
import "./categories.css";

function SubjectCard({ subject, onDeleteRequest, deleting }) {
  return (
    <div className="subj-card">
      <div className="subj-card-photo">
        {subject.teacher_photo ? (
          <img src={`http://localhost:3025/uploads/subjects/${subject.teacher_photo}`} alt={subject.name} />
        ) : (
          <div className="subj-card-avatar">
            <svg width="26" height="26" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" />
            </svg>
          </div>
        )}
      </div>

      <div className="subj-card-body">
        <h3 className="subj-card-name">{subject.name}</h3>
        {subject.teacher_name && (
          <p className="subj-card-teacher">
            <svg width="12" height="12" fill="currentColor" viewBox="0 0 24 24" style={{ marginLeft: 4, flexShrink: 0 }}>
              <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" />
            </svg>
            {subject.teacher_name}
          </p>
        )}
        {subject.teacher_phone && (
          <p className="subj-card-phone">
            <svg width="12" height="12" fill="currentColor" viewBox="0 0 24 24" style={{ marginLeft: 4, flexShrink: 0 }}>
              <path d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.46.57 3.58a1 1 0 0 1-.25 1.01l-2.2 2.2z" />
            </svg>
            {subject.teacher_phone}
          </p>
        )}
      </div>

      <div className="subj-card-actions">
        <Link to={`/dashboard/categories/${subject.id}`} className="subj-action-btn subj-edit-btn">
          <svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24">
            <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
          </svg>
          تعديل
        </Link>
        <button className="subj-action-btn subj-delete-btn" onClick={() => onDeleteRequest(subject)} disabled={deleting}>
          <svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24">
            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
          </svg>
          {deleting ? "..." : "حذف"}
        </button>
      </div>
    </div>
  );
}

function CardSkeleton() {
  return (
    <div className="subj-card subj-card-skeleton">
      <div className="sk-circle" />
      <div className="sk-line sk-line-lg" />
      <div className="sk-line sk-line-sm" />
      <div className="sk-actions">
        <div className="sk-btn" />
        <div className="sk-btn" />
      </div>
    </div>
  );
}

export default function Categories() {
  const [groups, setGroups]             = useState([]);
  const [classesLoading, setClassesLoading] = useState(true);
  const [pendingDelete, setPendingDelete] = useState(null); // { subject, classId }
  const [deleting, setDeleting]          = useState(false);

  useEffect(() => {
    Axios.get(ADMIN_ALL_CLASSES)
      .then((res) => {
        const classes = res.data.classes || [];
        setGroups(classes.map((c) => ({ ...c, subjects: [], loading: true })));
        setClassesLoading(false);

        classes.forEach((cls) => {
          Axios.get(`${SUBJECTS_BY_CLASS(cls.id)}?limit=100&page=1`)
            .then((r) => {
              const subjects = r.data.subjects || [];
              setGroups((prev) =>
                prev.map((g) => g.id === cls.id ? { ...g, subjects, loading: false } : g)
              );
            })
            .catch(() => {
              setGroups((prev) =>
                prev.map((g) => g.id === cls.id ? { ...g, loading: false } : g)
              );
            });
        });
      })
      .catch(() => setClassesLoading(false));
  }, []);

  async function confirmDelete() {
    if (!pendingDelete) return;
    setDeleting(true);
    try {
      await Axios.delete(ADMIN_SUBJECT_BY_ID(pendingDelete.subject.id));
      setGroups((prev) =>
        prev.map((g) =>
          g.id === pendingDelete.classId
            ? { ...g, subjects: g.subjects.filter((s) => s.id !== pendingDelete.subject.id) }
            : g
        )
      );
      setPendingDelete(null);
    } catch {
      // keep modal open on error
    } finally {
      setDeleting(false);
    }
  }

  return (
    <div className="dash-page">
      <div className="dash-page-header">
        <h1 className="dash-page-title">المواد الدراسية</h1>
        <Link className="dash-add-btn" to="/dashboard/category/add">
          <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
          </svg>
          إضافة مادة جديدة
        </Link>
      </div>

      {classesLoading ? (
        <div className="subj-class-section">
          <div className="sk-line sk-line-section" />
          <div className="subj-grid">
            {Array.from({ length: 4 }).map((_, i) => <CardSkeleton key={i} />)}
          </div>
        </div>
      ) : groups.length === 0 ? (
        <div className="table-state">
          <svg width="56" height="56" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zm0 12.5L3 11.09V17c0 2.76 4.03 5 9 5s9-2.24 9-5v-5.91L12 15.5z" />
          </svg>
          <p>لا توجد صفوف دراسية بعد</p>
          <small style={{ color: "#d1d5db", fontSize: "0.8rem" }}>
            أضف صفاً دراسياً أولاً من صفحة الصفوف ثم أضف موادها
          </small>
        </div>
      ) : (
        groups.map((cls) => (
          <div key={cls.id} className="subj-class-section">
            <div className="subj-class-header">
              <div className="subj-class-title-wrap">
                <div className="subj-class-dot" />
                <span className="subj-class-name">{cls.name}</span>
                <span className="subj-class-count">
                  {cls.loading ? "جاري التحميل..." : `${cls.subjects.length} مادة`}
                </span>
              </div>
              <div className="subj-class-divider" />
            </div>

            {cls.loading ? (
              <div className="subj-grid">
                {Array.from({ length: 3 }).map((_, i) => <CardSkeleton key={i} />)}
              </div>
            ) : cls.subjects.length === 0 ? (
              <div className="subj-empty">لا توجد مواد لهذا الصف بعد</div>
            ) : (
              <div className="subj-grid">
                {cls.subjects.map((subj) => (
                  <SubjectCard
                    key={subj.id}
                    subject={subj}
                    onDeleteRequest={(subject) => setPendingDelete({ subject, classId: cls.id })}
                    deleting={deleting && pendingDelete?.subject?.id === subj.id}
                  />
                ))}
              </div>
            )}
          </div>
        ))
      )}

      {/* Delete confirmation modal */}
      {pendingDelete && (
        <div className="confirm-overlay" onClick={() => !deleting && setPendingDelete(null)}>
          <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
            <div className="confirm-icon confirm-icon-danger">
              <svg width="28" height="28" fill="currentColor" viewBox="0 0 24 24">
                <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
              </svg>
            </div>
            <h3 className="confirm-title">تأكيد الحذف</h3>
            <p className="confirm-msg">
              هل تريد حذف مادة <strong>"{pendingDelete.subject.name}"</strong>؟<br />
              <span className="confirm-warning">لا يمكن التراجع عن هذا الإجراء</span>
            </p>
            <div className="confirm-actions">
              <button
                className="confirm-btn confirm-btn-cancel"
                onClick={() => setPendingDelete(null)}
                disabled={deleting}
              >
                إلغاء
              </button>
              <button
                className="confirm-btn confirm-btn-delete"
                onClick={confirmDelete}
                disabled={deleting}
              >
                {deleting ? "جاري الحذف..." : "حذف"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
